var _path, _ellipse, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12C2 14.34 2.06106 16.0017 2.25668 17.2352C2.4501 18.4548 2.76102 19.1562 3.18952 19.6492C3.62684 20.1523 4.28127 20.5491 5.39218 20.9735C6.21877 21.2892 7.21147 21.5906 8.45436 21.9679C8.90366 22.1042 9.38566 22.2506 9.90432 22.4111C11.7506 22.9824 13.0615 23.1022 13.9939 22.9235C14.8671 22.7562 15.4688 22.3176 15.928 21.562C16.4168 20.7577 16.753 19.5733 16.956 17.9349C17.1573 16.3094 17.2174 14.3317 17.2174 12C17.2174 9.66824 17.1573 7.69057 16.956 6.06507C16.753 4.42669 16.4168 3.24233 15.928 2.43805C15.4688 1.68242 14.8671 1.24377 13.9939 1.07648C13.0614 0.897844 11.7506 1.01757 9.90431 1.58891C9.38572 1.74939 8.90379 1.89568 8.45454 2.03204C7.21157 2.40934 6.21881 2.71068 5.39218 3.02646C4.28127 3.45084 3.62684 3.8476 3.18952 4.35072C2.76102 4.8437 2.4501 5.54513 2.25668 6.76477C2.06106 7.99824 2 9.65992 2 12Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 0.956522,
    ry: 0.960001,
    transform: "matrix(-1 0 0 1 13.4348 12.1621)",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2609 20.64C22.0435 20.64 22.0435 19.4727 22.0435 12.1554C22.0435 4.838 22.0435 3.36 17.2609 3.36",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.86c355ff3b323b8432bb8488c3d1f8f2.svg";
export { ForwardRef as ReactComponent };